import prepareTableColumnOptions from '@/utils/prepareTableColumnOptions';

export const QUOTE_TEMPLATE_MODEL_NAME = 'quote_templates';
export const QUOTE_TEMPLATE_TABLE_NAME = 'quoteTemplates';
export const QUOTE_TEMPLATE_SERVICE_ID_LABEL = 'Service';

export const QUOTE_TEMPLATE_TABLE_COLUMNS = {
  name: { label: 'Name', key: 'name' },
  description: { label: 'Description', key: 'description' },
  cost: { label: 'Total Cost', key: 'cost' },
  price: { label: 'Total Price', key: 'price' },
  active: { label: 'Active', key: 'active' },
  actions: { label: 'Actions', key: 'actions' },
  service_id: { label: QUOTE_TEMPLATE_SERVICE_ID_LABEL, key: 'service_id' },
};

export const QUOTE_TEMPLATE_TABLE_COLUMN_OPTIONS = prepareTableColumnOptions(QUOTE_TEMPLATE_TABLE_COLUMNS);

export const QUOTE_TEMPLATE_TABLE_DEFAULT_COLUMNS = [
  QUOTE_TEMPLATE_TABLE_COLUMNS.name,
  QUOTE_TEMPLATE_TABLE_COLUMNS.description,
  QUOTE_TEMPLATE_TABLE_COLUMNS.cost,
  QUOTE_TEMPLATE_TABLE_COLUMNS.price,
  QUOTE_TEMPLATE_TABLE_COLUMNS.active,
  QUOTE_TEMPLATE_TABLE_COLUMNS.actions,
];
